module.exports = __webpack_public_path__ + "static/media/halfv2.830b57ff.png";